module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.tag || 'section', {
    tag: "component",
    class: [
      'block',
      ("block--" + (_vm.block || 'accent')),
      _vm.angleSet.angle ? ("angle-block--" + (_vm.angleSet.angle) + (_vm.angleSet.reversed ? "-reversed" : "")) : "",
      {
        'block--cover': _vm.cover,
        'block--center': _vm.center,
        'block--grow': _vm.grow,
      } ]
  }, [(_vm.image) ? _c('b', {
    class: [
      "block__bg"
    ],
    style: ({
      backgroundImage: ("url('" + _vm.image + "')"),
    })
  }) : _vm._e(), _vm._v(" "), (_vm.slug) ? _c('span', {
    staticClass: "anchor",
    attrs: {
      "id": _vm.slug
    }
  }, [(_vm.trigger) ? _c('span', {
    attrs: {
      "data-header-trigger": ""
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f33dee1"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/modules/Block.vue
// module id = 234
// module chunks = 0